/** 
 * 异步请求总控中心
 * put相当于redux的dispatch的作用
 * */
import { fork, all } from 'redux-saga/effects';
import { getMenuList } from '@/reducers/home/saga';
import userSaga from '@/reducers/user/combineSaga'; // 用户管理
import orderSaga from '@/reducers/order/combineSaga'; // 订单管理
import financeSaga from '@/reducers/finance/combineSaga';// 财务管理
import aftersaleSaga from '@/reducers/aftersale/combineSaga';// 售后管理
import clientSaga from '@/reducers/client/combineSaga';// 客户端管理
import systemSaga from '@/reducers/system/combineSaga';// 系统管理
import marketSagas from '@/reducers/market/combineSaga';// 营销管理
import operationSagas from '@/reducers/operation/combineSaga';// 市场管理
import auditSagas from '@/reducers/audit/combineSaga';// 市场管理
import contractSagas from '@/reducers/contract/combineSaga';// 合同管理
import companyhelpSagas from '@/reducers/companyhelp/combineSaga';// 运营帮助中心
import reportSagas from '@/reducers/report/combineSaga';// 报表管理
import premissionsSagas from '@/reducers/permissions/combineSaga'; // 权限管理

const combineSaga = (sagas, modules) => {
    let result = [...sagas];
    for (let i = 0; i < modules.length; i++) {
        const module = modules[i];
        result = result.concat(module.map((item) => {
            return fork(item);
        }));
    }
    return result;
};

const modules = [
    userSaga,
    orderSaga,
    financeSaga,
    aftersaleSaga,
    clientSaga,
    systemSaga,
    marketSagas,
    operationSagas,
    auditSagas,
    contractSagas,
    companyhelpSagas,
    reportSagas,
    premissionsSagas,
];
let sagas = [].concat(fork(getMenuList));
sagas = combineSaga(sagas, modules);
export default function* rootSaga() {
    yield all(sagas);
}